export default __webpack_public_path__ + "static/media/2.73278dc7.webp";